import { render, staticRenderFns } from "./PastOrders.vue?vue&type=template&id=1a73adf4&"
import script from "./PastOrders.vue?vue&type=script&lang=js&"
export * from "./PastOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports